import { Divider, Group, Switch, Text } from "@mantine/core";
import * as React from "react";
import { PANEL_FONT, PANEL_LAYOUT, PANEL_SPACE } from "./tokens";

/**
 * A card's opening switch with a divider under it (Figma "Option"): the switch, then its
 * 13px label. The label names what the switch allows, as the frames phrase it.
 */
export function ToggleRow({
  label,
  checked,
  onChange,
  disabled,
}: {
  label: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
}) {
  return (
    <>
      <Switch
        label={label}
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.currentTarget.checked)}
        styles={{ label: { fontSize: PANEL_FONT.body, paddingInlineStart: PANEL_SPACE.card } }}
      />
      <Divider />
    </>
  );
}

/** A column's heading inside a card (Figma "Series Colors", "Slide Headers"). */
export function ColumnHeading({ children }: { children: React.ReactNode }) {
  return (
    <Text fw={600} lh={1.25}>
      {children}
    </Text>
  );
}

/**
 * A field with its label beside the input (Figma "Field" in Brand Configuration): a 100px
 * label, then the input filling the row. `children` gets the id to put on the input, so the
 * label names it.
 */
export function InlineField({ label, children }: { label: string; children: (id: string) => React.ReactNode }) {
  const id = React.useId();
  return (
    <Group gap={PANEL_SPACE.field} wrap="nowrap">
      <Text component="label" htmlFor={id} w={PANEL_LAYOUT.inlineLabelWidth} style={{ flexShrink: 0 }} lh={1.25}>
        {label}
      </Text>
      <div style={{ flex: 1, minWidth: 0 }}>{children(id)}</div>
    </Group>
  );
}
